
import { LazyPage } from "../components-ui/loadable";

//Category
export const MonHocPage = LazyPage(import("./category/mon-hoc"));
export const ThanhPhanMonPage = LazyPage(import("./category/thanh-phan-mon"));
export const ThanhPhanThiPage = LazyPage(import("./category/thanh-phan-thi"));
export const CongThucTinhDiemPage = LazyPage(import("./category/cong-thuc-diem"));
export const QuyChePage = LazyPage(import("./category/quy-che"));
export const DiemQuyDoiPage = LazyPage(import("./category/diem-quy-doi"));
export const XepLoaiHocTapPage = LazyPage(import("./category/xep-loai-hoc-tap"));
export const XepHangTotNghiepPage = LazyPage(import("./category/xep-hang-tot-nghiep"));
export const XepLoaiChungChiPage = LazyPage(import("./category/xep-loai-chung-chi"));
export const LoaiChungChiPage = LazyPage(import("./category/loai-chung-chi"));
export const LoaiChungChiChungNhanPage = LazyPage(import("./category/loai-chung-chi-chung-nhan"));
export const LoaiBangTotNghiepPage = LazyPage(import("./category/loai-bang-tot-nghiep"));
export const TieuDeBaoCaoPage = LazyPage(import("./category/tieu-de-bao-cao"));
export const HinhThucMienGiamPage = LazyPage(import("./category/tham-so-he-thong"));
export const DiemKyHieuPage = LazyPage(import("./category/diem-ky-hieu"));
//Hệ thống
export const ThamSoHeThongPage = LazyPage(import("./category/tham-so-he-thong"));
export const QuanLyBieuMauPage = LazyPage(import("./quan-ly-bieu-mau"));

export const InBangDiemPage = LazyPage(import("./in-bang-diem"));
export const TongHopKyPage = LazyPage(import("./tong-hop-diem/tong-hop-ky"));
export const TongHopNamPage = LazyPage(import("./tong-hop-diem/tong-hop-nam"));
export const TongHopToanKhoaPage = LazyPage(import("./tong-hop-diem/tong-hop-toan-khoa"));
export const TienDoNhapDiemLopHanhChinhPage = LazyPage(import("./tong-hop/tien-do-nhap-diem-lop-hanh-chinh"));
export const TienDoNhapDiemLopTinChiPage = LazyPage(import("./tong-hop/tien-do-nhap-diem-lop-tin-chi"));
export const XetHocVuPage = LazyPage(import("./xet-hoc-vu"));
export const XetKhoaLuanPage = LazyPage(import("./xet-khoa-luan"));
export const XetTotNghiepPage = LazyPage(import("./xet-tot-nghiep"));
export const XetChungChiPage = LazyPage(import("./xet-chung-chi"));
export const XetThucTapPage = LazyPage(import("./xet-thuc-tap"));
export const chuongTrinhDaoTaoPage = LazyPage(import("./chuong-trinh-dao-tao"));
export const BaoCaoThongKePage = LazyPage(import("./bao-cao-thong-ke"));
export const ChungChiChungNhanPage = LazyPage(import("./chung-chi-chung-nhan"));
export const TraCuuDiemPage = LazyPage(import("./tra-cuu-diem"));
export const NhapDiemTheoSinhVienPage = LazyPage(import("./nhap-diem-theo-sinh-vien"));
export const ThiLaiHocLaiPage = LazyPage(import("./thi-lai-hoc-lai"));
export const TinhTrangNoMonPage = LazyPage(import("./tinh-trang-no-mon"));
export const HocPhanMienPage = LazyPage(import("./hoc-phan-mien"));
export const DanhSachNganh2Page = LazyPage(import("./quan-ly-nganh-hai/danh-sach-nganh-2/DanhSachNganh2Page"));
export const TongHopToanKhoaNganh2Page = LazyPage(import("./quan-ly-nganh-hai/tong-hop-toan-khoa/TongHopToanKhoaNganh2"));